import React, { useEffect } from 'react';
import { css } from '@emotion/react';
import theme from '@styles/theme';
import { ValueCheckIcon, ToastEntryIcon } from 'public/assets';
import { getToastTime } from '@common/utils';
import { Statement } from '@/customTypes/chatStory';
import { PlayChapterInfo } from '@customTypes/chapter';
import { setCustomNameToText } from '@service/ChapterService';

interface IToastItem {
  toast: Statement;
  onRemoveToast?: (toast: Statement) => void;
  onClickToast?: () => void;
  playChapterInfo?: PlayChapterInfo;
}

const getToastIcon = (toastOption?: number) => {
  const Icon =
    toastOption === 1
      ? ValueCheckIcon
      : toastOption === 2
      ? ToastEntryIcon
      : undefined;
  return Icon ? <Icon width={24} height={24} className="toast-icon" /> : null;
};

const ToastItem = ({
  toast,
  onRemoveToast,
  onClickToast,
  playChapterInfo,
}: IToastItem) => {
  useEffect(() => {
    const msec = getToastTime(toast.message || '');

    const timer = setTimeout(() => {
      onRemoveToast && onRemoveToast(toast);
    }, msec);

    return () => {
      clearTimeout(timer);
    };
  }, [toast.message]);

  if (!toast.message) {
    return null;
  }

  return (
    <div css={toastContainer}>
      <div className="toast" onClick={onClickToast}>
        <div className="toast-icon">{getToastIcon(toast.toastOption)}</div>
        <div className="toast-text">
          {setCustomNameToText({
            text: toast?.message,
            playChapterInfo,
          }) || ''}
        </div>
      </div>
    </div>
  );
};
const toastContainer = css`
  width: 100%;
  max-width: 800px;
  display: flex;
  justify-content: center;
  margin-top: 10px;

  .toast {
    max-width: 450px;
    background-color: ${theme.colors.white};
    border: 1px solid ${theme.colors.gray300};
    box-sizing: border-box;
    display: flex;
    align-items: center;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
    border-radius: 24px;
    border: none;
    padding: 12px 20px 12px 12px;

    .toast-text {
      font-size: 1em;
      font-weight: 400;
    }

    .toast-icon {
      margin-right: 0.75em;
    }

    @media screen and (max-width: ${theme.devices.mobile}) {
      max-width: 335px;
    }
  }

  @media screen and (max-width: ${theme.devices.mobile}) {
    bottom: 36%;
  }
`;

export default React.memo(ToastItem);
